import {lazy} from 'react';
import GenericFallbackSuspense from '../../../v2/components/ui/GenericFallback/GenericFallbackSuspense';

const DeliveryOptionBody = lazy(() => (
  import('./DeliveryOptionBody'/* webpackChunkName: 'DeliveryOptionBody' */)
));

export default function DeliveryOptionBodyLazyLoader(props) {
  return (
    <GenericFallbackSuspense>
      <DeliveryOptionBody {...props} />
    </GenericFallbackSuspense>
  );
}
